import React from 'react'
import { Link } from 'react-router-dom'

import { Wrap, Title, Illustration, CompletedLabel } from './styled'

import { IQuiz } from 'src/api/quizzes/types'
import { NEW_QUIZ, COMPLETE_QUIZ } from 'src/constants/routes'

interface IQuizTileProps {
  quiz: IQuiz
  complete?: boolean
}

const QuizTile: React.FC<IQuizTileProps> = ({ quiz, complete = false }) => (
  <Link
    to={
      complete
        ? COMPLETE_QUIZ.replace(':id', String(quiz.id))
        : NEW_QUIZ.replace(':id', String(quiz.id))
    }
  >
    <Wrap colors={quiz.colors}>
      {complete && <CompletedLabel>completed</CompletedLabel>}
      <Illustration src={quiz.imageUrl} alt={quiz.title} />
      <Title color={quiz.colors.text}>{quiz.title}</Title>
    </Wrap>
  </Link>
)

export default QuizTile
